import type { Middleware } from '@arcubase/client-ts'
import { getAuthHeaders } from '@/auth/sessionRuntime'

export const slauthSessionMiddleware: Middleware = async (context, next) => {
  context.config.headers = await getAuthHeaders(null, context.config.headers || {})
  return await next()
}
